import { MAP_POINT_MAX_AREA_HA, MapPointDraft, MapPointEditorResult } from './map-point.models';
import { EDITOR_INPUT_STYLE, EDITOR_BUTTON_STYLE, EDITOR_PRIMARY_STYLE, styleEditorContainer } from './map-editor-ui';

export function createPointEditorForm(
  draft: MapPointDraft,
  translate: (key: string) => string,
  finish: (result?: MapPointEditorResult) => void
): HTMLFormElement {
  const form = document.createElement('form');
  styleEditorContainer(form);
  form.setAttribute('aria-label', translate(draft.id ? 'Map_edit_point_tr' : 'Map_add_point_tr'));
  const title = document.createElement('strong');
  title.textContent = translate(draft.id ? 'Map_edit_point_tr' : 'Map_add_point_tr');
  title.style.paddingRight = '20px';
  form.appendChild(title);

  const input = (key: string, value: string, numeric = false, min?: number, max?: number) => {
    const label = document.createElement('label');
    label.style.cssText = 'display:flex;flex-direction:column;gap:4px;';
    label.appendChild(document.createTextNode(translate(key)));
    const field = document.createElement('input');
    field.type = numeric ? 'number' : 'text';
    field.value = value;
    field.style.cssText = EDITOR_INPUT_STYLE;
    if (numeric) {
      field.required = true;
      field.step = 'any';
      field.min = String(min);
      field.max = String(max);
    } else field.maxLength = 120;
    label.appendChild(field);
    form.appendChild(label);
    return field;
  };
  const name = input('Map_point_name_tr', draft.name);
  const lat = input('Map_point_latitude_tr', String(draft.lat ?? ''), true, -90, 90);
  const lng = input('Map_point_longitude_tr', String(draft.lng ?? ''), true, -180, 180);
  const area = input('Map_point_area_ha_tr', String(draft.areaHa ?? ''), true, 0.01, MAP_POINT_MAX_AREA_HA);
  area.dataset['testid'] = 'map-point-area';
  const values = () => ({
    ...draft,
    name: name.value.trim(),
    lat: lat.value ? Number(lat.value) : null,
    lng: lng.value ? Number(lng.value) : null,
    areaHa: area.value ? Number(area.value) : null,
  });
  const button = (key: string, action: () => void) => {
    const element = document.createElement('button');
    element.type = 'button';
    element.textContent = translate(key);
    element.style.cssText = EDITOR_BUTTON_STYLE;
    element.addEventListener('click', action);
    form.appendChild(element);
    return element;
  };
  button('Map_point_choose_on_map_tr', () => finish({ ...values(), action: 'pick' }));
  const save = button('Save_tr', () => {});
  save.type = 'submit';
  save.style.cssText += EDITOR_PRIMARY_STYLE;
  button('cancel_tr', () => finish());
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (form.reportValidity()) finish({ ...values(), action: 'save' });
  });
  return form;
}
